// extracted by mini-css-extract-plugin
export var list = "PortfolioList-module--list--oPAGl";
export var paginationContainer = "PortfolioList-module--paginationContainer--p9qEP";